import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableProductChoice = loadable(() => import('./ProductChoice'), {
  fallback: <LoadingScreen />,
});

export default LoadableProductChoice;
